import { ROUTES } from "constants/routes";
import PrivateLayout from "layouts/private-layout";
// import PrivateLayout from "layouts/public-layout";
// import About from "pages/About";
// import Home from "pages/Home";
// import HowItWorks from "pages/Home/HowItWorks";
import ApprovalPolicy from "pages/approval-policy";
import CartPage from "pages/cart";
import DashboardPage from "pages/dashboard";
import DocumentsPage from "pages/documents";
// import FAQComponent from "pages/faq";
import ForgotPassword from "pages/forget-password";
import ListEquipment from "pages/list-equipment";
import ListingDetail from "pages/listing-detail";
import LoginForm from "pages/login";
import Logout from "pages/logout";
import MessagesPage from "pages/messages";
import MyListingPage from "pages/my-listings";
import OurStoryPage from "pages/our-story";
import PaymentPage from "pages/payment";
import PersonalRentalPage from "pages/personal-rental";
import PersonalRentalDetailsPage from "pages/personal-rental/details";
import MyProfile from "pages/profile";
import RentalHistoryPage from "pages/rental-history";
import ResetPassword from "pages/reset-password";
import SavedAddressPage from "pages/saved-address";
import SearchListing from "pages/search-listing";
import SignupForm from "pages/signup";
import SavedCardPage from "pages/saved-cards";
import ListingDetailsOwner from "pages/listing-details-owner";
// import BlogPage from "pages/blogs/index";
// import ViewBlog from "pages/blogs/view";

const Routes: any = [
  // {
  //   label: "Home",
  //   path: "/",
  //   element: (
  //     <PrivateLayout>
  //       <Home />
  //     </PrivateLayout>
  //   ),
  // },
  {
    label: "SearchListing",
    path: "/",
    element: (
      <PrivateLayout>
        <SearchListing />
      </PrivateLayout>
    ),
  },
  {
    label: "SearchListing",
    path: "/search-listing",
    element: (
      <PrivateLayout>
        <SearchListing />
      </PrivateLayout>
    ),
  },
  {
    label: "ListEquipment",
    path: "list-equipment",
    element: (
      <PrivateLayout>
        <ListEquipment />
      </PrivateLayout>
    ),
  },
  {
    label: "ListingDetails",
    path: "/listing-detail/:id",
    element: (
      <PrivateLayout>
        <ListingDetail />
      </PrivateLayout>
    ),
  },
  {
    label: "ListingDetailsOwner",
    path: "/listing-detail-owner/:id",
    element: (
      <PrivateLayout>
        <ListingDetailsOwner />
      </PrivateLayout>
    ),
  },
  { label: "Login", path: "/signin", element: <LoginForm /> },
  { label: "Logout", path: "/logout", element: <Logout /> },
  {
    label: "Forget Password",
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    label: "Reset Password",
    path: "/reset-password",
    element: <ResetPassword />,
  },

  { label: "Signup", path: "/signup", element: <SignupForm /> },
  // {
  //   label: "About",
  //   path: "/about-us",
  //   element: (
  //     <PrivateLayout>
  //       <About />
  //     </PrivateLayout>
  //   ),
  // },
  {
    label: "Peronal Rental",
    path: "/booking-history",
    element: (
      <PrivateLayout>
        <PersonalRentalPage />
      </PrivateLayout>
    ),
  },
  {
    label: "Peronal Rental Details",
    path: "/booking-history/:id",
    element: (
      <PrivateLayout>
        <PersonalRentalDetailsPage />
      </PrivateLayout>
    ),
  },
  // {
  //   label: "How it works",
  //   path: "/how-it-works",
  //   element: (
  //     <PrivateLayout>
  //       <HowItWorks />
  //     </PrivateLayout>
  //   ),
  // },
  {
    label: "Profile",
    path: ROUTES.PROFILE,
    element: (
      <PrivateLayout>
        <MyProfile />
      </PrivateLayout>
    ),
  },

  {
    label: "Approval Policy",
    path: ROUTES.APPROVAL_POLICY,
    element: (
      <PrivateLayout>
        <ApprovalPolicy />
      </PrivateLayout>
    ),
  },
  // {
  //   label: "FAQs",
  //   path: "/faq",
  //   element: (
  //     <PrivateLayout>
  //       <FAQComponent userType="renter" />
  //     </PrivateLayout>
  //   ),
  // },

  {
    label: "Cart",
    path: "/cart",
    element: (
      <PrivateLayout>
        <CartPage />
      </PrivateLayout>
    ),
  },
  {
    label: "Payment",
    path: "/payment",
    element: (
      <PrivateLayout>
        <PaymentPage />
      </PrivateLayout>
    ),
  },
  {
    label: "Dashboard",
    path: "/dashboard",
    element: (
      <PrivateLayout>
        <DashboardPage />
      </PrivateLayout>
    ),
  },
  {
    label: "Dashboard",
    path: "/rental",
    element: (
      <PrivateLayout>
        <RentalHistoryPage />
      </PrivateLayout>
    ),
  },
  {
    label: "Listing",
    path: "/listing",
    element: (
      <PrivateLayout>
        <MyListingPage />
      </PrivateLayout>
    ),
  },
  {
    label: "Messages",
    path: "/messages",
    element: (
      <PrivateLayout>
        <MessagesPage />
      </PrivateLayout>
    ),
  },
  {
    label: "Messages",
    path: "/messages/:id",
    element: (
      <PrivateLayout>
        <MessagesPage />
      </PrivateLayout>
    ),
  },
  {
    label: "Documents",
    path: "/documents",
    element: (
      <PrivateLayout>
        <DocumentsPage />
      </PrivateLayout>
    ),
  },
  { label: "Our Story", path: "/our-story", element: <OurStoryPage /> },
  {
    label: "Saved Address",
    path: "/saved-address",
    element: (
      <PrivateLayout>
        <SavedAddressPage />
      </PrivateLayout>
    ),
  },
  {
    label: "Saved Cards",
    path: "/saved-cards",
    element: (
      <PrivateLayout>
        <SavedCardPage />
      </PrivateLayout>
    ),
  },
  {
    label: "Customer Support",
    path: "/owners#mobile-widget",
    element: <h1>Customer Support</h1>,
  },
  // {
  //   label: "Blog",
  //   path: "/blogs",
  //   element: (
  //     <PrivateLayout>
  //       <BlogPage />
  //     </PrivateLayout>
  //   ),
  // },
  // {
  //   label: "Blog",
  //   path: "/blogs/view",
  //   element: (
  //     <PrivateLayout>
  //       <ViewBlog />
  //     </PrivateLayout>
  //   ),
  // },
];

export default Routes;
